import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-mat-confirm-dialog',
  templateUrl: './mat-confirm-dialog.component.html',
  styleUrls: ['./mat-confirm-dialog.component.scss'],
  standalone: false,
})
export class MatConfirmDialogComponent implements OnInit {
  safeHtml: SafeHtml;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<MatConfirmDialogComponent>,
    private sanitizer: DomSanitizer,
  ) {
    this.safeHtml = this.sanitizer.bypassSecurityTrustHtml(this.data.message);
  }

  ngOnInit() {}

  closeDialog() {
    this.dialogRef.close(false);
  }
}
